import logger from "@insite/client-framework/Logger";
import React, { useState } from "react";

export interface ModelLookupApiParameter {
    ModelNumber: string;
}

export type ModelLookupResult = {
    productId: string;
};

const getModelLookupByModelNumber = async (modelNumber: string) => {
    try {
        const apiUrl = `${window.origin}/api/auersteel/v1/modellookup/model/${modelNumber}`;
        const apiResponse = await fetch(apiUrl).then(response => {
            const responseJson = response.json();
            return responseJson;
        });

        return apiResponse;
    } catch (ex) {
        if (ex) {
            logger.debug(`Failed to retrieve model lookup results: ${ex.message}`);
        }
    }
};

const getModelPartsLookupByModelNumber = async (modelNumber: string) => {
    try {
        const apiUrl = `${window.origin}/api/auersteel/v1/modellookup/parts/${modelNumber}`;

        const apiResponse = await fetch(apiUrl).then(response => {
            return response.json();
        });

        return apiResponse;
    } catch (ex) {
        if (ex) {
            logger.debug(`Failed to retrieve model lookup results: ${ex.message}`);
        }
    }
};

const getModelProductByProductNumber = async (productNumber: string) => {
    try {
        const apiUrl = `${window.origin}/api/v1/products?model.erpNumbers=${productNumber}&expand=brand`;

        const apiResponse = await fetch(apiUrl).then(response => {
            return response.json();
        });

        const productResult = apiResponse.products.length > 0 ? apiResponse.products[0] : {};
        return productResult;
    } catch (ex) {
        if (ex) {
            logger.debug(`Failed to retrieve model lookup results: ${ex.message}`);
        }
    }
};

export { getModelLookupByModelNumber, getModelProductByProductNumber, getModelPartsLookupByModelNumber };
